import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";

const hhmm = (iso) => new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/London" });

// Shown to every admin while a support key is active.
export const SupportBanner = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/admin/support-access").then((r) => alive && setS(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  if (!s?.active) return null;
  const revoke = async () => {
    if (!window.confirm("Revoke support access now?")) return;
    try { await api.delete("/admin/support-access"); setS({ active: false }); toast.success("Support access revoked"); } catch (e) { toast.error(errorMessage(e)); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-amber-500/40 bg-amber-500/15 px-4 py-1.5 text-xs" role="status" data-testid="support-banner">
      <KeyRound className="h-3.5 w-3.5" />
      <span>Support access is on until {hhmm(s.expires_at)}{s.include_customer_data ? " – with customer data" : ""}.</span>
      <button type="button" className="font-medium underline" onClick={revoke} data-testid="support-banner-revoke">Revoke</button>
      <Link to="/admin/health" className="underline text-muted-foreground" data-testid="support-banner-details">Details</Link>
    </div>
  );
};
